<template>
  <v-container fluid>
    <!--BEGIN Dialog-->
    <v-row justify="center">
      <v-dialog
          v-model="dialog"
          persistent
          max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Add Publication</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-form ref="publicationForm" v-model="isValid">
                <v-row>
                  <v-col
                      cols="12"
                      sm="6"
                      md="6"
                  >
                    <v-text-field
                        label="Title*"
                        required
                        :rules="[rules.required]"
                        v-model="formData.title"
                    ></v-text-field>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="6"
                      md="6"
                  >
                    <v-text-field
                        label="Report Type*"
                        required
                        :rules="[rules.required]"
                        v-model="formData.publication_type"
                    ></v-text-field>
                  </v-col>
                  <v-col
                      cols="12"
                      sm="12"
                      md="12"
                  >
                    <v-file-input
                        label="Upload Attachment"
                        :rules="[rules.required]"
                        @change="uploadImage"
                    />
                  </v-col>
                  <v-col cols="12">
                    <span>Description</span>
                    <VueEditor v-model="formData.description"/>
                  </v-col>
                </v-row>
              </v-form>
            </v-container>
            <small>*indicates required field</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                color="blue darken-1"
                text
                @click="dialog = false"
            >
              Close
            </v-btn>
            <v-btn
                color="blue darken-1"
                text
                @click="save"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
    <!--END Dialog-->
    <v-card flat>
      <v-card-title>
        <v-spacer/>
        <v-btn @click="dialog=true" class="primary"><v-icon>mdi-plus</v-icon>Add Publication</v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-data-table
            :headers="headers"
            :items="publications"
        >
          <template v-slot:item.ID="{index}">
            <span>{{index+1}}</span>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { VueEditor } from 'vue2-editor'
import helpers from "../../../../shared/utilities/helpers";
export default {
  name: "PublicationCard",
  components: { VueEditor },
  beforeRouteEnter(to,from,next){
    next(v=>{
      v.$store.dispatch('Publication/publications');
    })
  },
  data: () => ({
    dialog: false,
    isValid: false,
    formData:{
      title:"",
      description:"",
      publication_type:"",
      attachment:""
    },
    rules: {
      required: value => !!value || 'Required!',
    },
    headers: [
      {
        text: '#S/N',
        align: '',
        sortable: true,
        value: 'ID'
      },
      {
        text: 'Title',
        align: '',
        sortable: true,
        value: 'title'
      },
      {
        text: 'Description',
        align: '',
        sortable: true,
        value: 'description'
      }
    ],
  }),
  computed:{
    publications(){
      return this.$store.getters['Publication/PublicationGetter']("publications")
    }
  },
  methods: {
    async uploadImage(fileInput){
      this.formData.attachment=await helpers.uploadImage(fileInput);
    },
    save() {
      this.formData.description=helpers.removeTags(this.formData.description);
      if (!this.isValid) {
        this.$refs.publicationForm.validate()
      }
      else{
        this.$store.dispatch('Publication/publication', { ...this.formData});
        this.dialog=false
      }
    },
  }
}
</script>

<style scoped>

</style>
